export const HOMEPAGE =
  'https://docs.google.com/document/u/1/d/e/2PACX-1vQTM0SoSQ2FHrl39lkh5kph6weUHb3n2_DiuqvXGv8WX9xEEpvwF8APo2hX5SQJTuPRF65kb2VPtYjh/pub'

export const PERSONAL_INFORMATION =
  'https://docs.google.com/document/u/1/d/e/2PACX-1vQTM0SoSQ2FHrl39lkh5kph6weUHb3n2_DiuqvXGv8WX9xEEpvwF8APo2hX5SQJTuPRF65kb2VPtYjh/pub#h.yvmd8w8bwpxr'

export const EDUCATIONAL_PURPOSES =
  'https://docs.google.com/document/u/1/d/e/2PACX-1vQTM0SoSQ2FHrl39lkh5kph6weUHb3n2_DiuqvXGv8WX9xEEpvwF8APo2hX5SQJTuPRF65kb2VPtYjh/pub#h.hkn6t7zd61tl'

export const SELL =
  'https://docs.google.com/document/u/1/d/e/2PACX-1vQTM0SoSQ2FHrl39lkh5kph6weUHb3n2_DiuqvXGv8WX9xEEpvwF8APo2hX5SQJTuPRF65kb2VPtYjh/pub#h.3ev4ttodkahb'

export const THIRD_PARTY_ADVERTISING =
  'https://docs.google.com/document/u/1/d/e/2PACX-1vQTM0SoSQ2FHrl39lkh5kph6weUHb3n2_DiuqvXGv8WX9xEEpvwF8APo2hX5SQJTuPRF65kb2VPtYjh/pub#h.l0m62oplmk8c'

export const BEHAVIORALLY_TARGETED_ADVERTISING =
  'https://docs.google.com/document/u/1/d/e/2PACX-1vQTM0SoSQ2FHrl39lkh5kph6weUHb3n2_DiuqvXGv8WX9xEEpvwF8APo2hX5SQJTuPRF65kb2VPtYjh/pub#h.nink9dv8l0c9'

export const CONTEXTUAL_TARGETING =
  'https://docs.google.com/document/u/1/d/e/2PACX-1vQTM0SoSQ2FHrl39lkh5kph6weUHb3n2_DiuqvXGv8WX9xEEpvwF8APo2hX5SQJTuPRF65kb2VPtYjh/pub#h.ee0osr715ctq'

export const LEARNER =
  'https://docs.google.com/document/u/1/d/e/2PACX-1vQTM0SoSQ2FHrl39lkh5kph6weUHb3n2_DiuqvXGv8WX9xEEpvwF8APo2hX5SQJTuPRF65kb2VPtYjh/pub#h.3bx1oc404smi'

export const IP_ADDRESS =
  'https://docs.google.com/document/u/1/d/e/2PACX-1vQTM0SoSQ2FHrl39lkh5kph6weUHb3n2_DiuqvXGv8WX9xEEpvwF8APo2hX5SQJTuPRF65kb2VPtYjh/pub#h.ba8hpn3k3f4v'

export const COOKIES =
  'https://docs.google.com/document/u/1/d/e/2PACX-1vQTM0SoSQ2FHrl39lkh5kph6weUHb3n2_DiuqvXGv8WX9xEEpvwF8APo2hX5SQJTuPRF65kb2VPtYjh/pub#h.h60uw4d25po7'

export const LOCAL_STORAGE =
  'https://docs.google.com/document/u/1/d/e/2PACX-1vQTM0SoSQ2FHrl39lkh5kph6weUHb3n2_DiuqvXGv8WX9xEEpvwF8APo2hX5SQJTuPRF65kb2VPtYjh/pub#h.n77u0jkg7mlr'

export const SERVER_LOGS =
  'https://docs.google.com/document/u/1/d/e/2PACX-1vQTM0SoSQ2FHrl39lkh5kph6weUHb3n2_DiuqvXGv8WX9xEEpvwF8APo2hX5SQJTuPRF65kb2VPtYjh/pub#h.vsgk6thytvy6'

export const DEIDENTIFIED =
  'https://docs.google.com/document/u/1/d/e/2PACX-1vQTM0SoSQ2FHrl39lkh5kph6weUHb3n2_DiuqvXGv8WX9xEEpvwF8APo2hX5SQJTuPRF65kb2VPtYjh/pub#h.iha2iybof86d'

// Tags on Privacy Policy webpage corresponding to the sections of the policy
// Used as anchors for scrolling to relevant sections
export const PRIVACY_TAGS = {
  POLICY: 'policy',
  INTRODUCTION_AND_SCOPE: 'introduction-and-scope',
  ACKNOWLEDGMENT_AND_CONSENT: 'acknowledgment-and-consent',
  CHILDREN_UNDER_THE_AGE: 'children-under-the-age',
  CHANGES_TO_OUR_PRIVACY_POLICY: 'changes-to-our-privacy-policy',
  WHAT_INFORMATION_DOES_SCHOOLHOUSE_COLLECT: 'what-information-does-schoolhouse-collect',
  WHAT_INFORMATION_DOES_SCHOOLHOUSE_COLLECT_1: 'what-information-does-schoolhouse-collect-1',
  WHAT_INFORMATION_DOES_SCHOOLHOUSE_COLLECT_2: 'what-information-does-schoolhouse-collect-2',
  WHAT_INFORMATION_DOES_SCHOOLHOUSE_COLLECT_3: 'what-information-does-schoolhouse-collect-3',
  ONLINE_ANALYTICS: 'online-analytics',
  HOW_DOES_SCHOOLHOUSE_USE_THE_INFORMATION: 'how-does-schoolhouse-use-the-information',
  WILL_SCHOOLHOUSE_SHARE_ANY: 'will-schoolhouse-share-any',
  HOW_DOES_SCHOOLHOUSE_PROTECT: 'how-does-schoolhouse-protect',
  HOW_LONG_DOES_SCHOOLHOUSE_KEEP: 'how-long-does-schoolhouse-keep',
  SCHOOLHOUSES_COMMITMENT_TO_PROVIDING: 'schoolhouses-commitment-to-providing',
  SCHOOLHOUSES_COMMITMENT_TO_PROVIDING_EXERCISE: 'schoolhouses-commitment-to-providing-exercise',
  SCHOOLHOUSES_COMMITMENT_TO_PROVIDING_ACCESS: 'schoolhouses-commitment-to-providing-access',
  SCHOOLHOUSES_COMMITMENT_TO_PROVIDING_DELETE: 'schoolhouses-commitment-to-providing-delete',
  SCHOOLHOUSES_COMMITMENT_TO_PROVIDING_OBJECT: 'schoolhouses-commitment-to-providing-object',
  ADDITIONAL_INFORMATION_OR_ASSISTANCE: 'additional-information-or-assistance',
  WHAT_COMMUNICATIONS_WILL_I_RECEIVE: 'what-communications-will-i-receive',
  THIRD_PARTY_AUTHENTICATION_SERVICES: 'third-party-authentication-services',
  THIRD_PARTY_SERVICES: 'third-party-services',
  WHAT_IF_I_AM_NOT_IN_THE_US: 'what-if-i-am-not-in-the-us',
  IS_SCHOOLHOUSE_A_CONTROLLER: 'is-schoolhouse-a-controller',
  CALIFORNIA_PRIVACY_DISCLOSURES: 'california-privacy-disclosures',
  CONTACTING_SCHOOLHOUSE: 'contacting-schoolhouse',
} as const
